import { useCallback, useEffect } from 'react';

const useViewportHeight = () => {
    const updateViewportHeight = useCallback(() => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, []);

    useEffect(() => {
        // Set initial viewport height
        updateViewportHeight();

        // Add resize listener with proper cleanup
        window.addEventListener('resize', updateViewportHeight);

        return () => {
            window.removeEventListener('resize', updateViewportHeight);
        };
    }, [updateViewportHeight]);
};

export default useViewportHeight;
